/**
 * 移动端客户列表页
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  List,
  PullToRefresh,
  Empty,
  Skeleton,
  InfiniteScroll,
  SearchBar,
  Tag,
  Dialog,
} from 'antd-mobile';
import { adminUserApi } from '../../api/index';
import Toast from 'antd-mobile/es/components/toast';

export default function MobileCustomerListPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [customers, setCustomers] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [refreshFlag, setRefreshFlag] = useState(0);

  useEffect(() => {
    fetchCustomers(1, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKeyword, refreshFlag]);

  const fetchCustomers = async (pageNum, append = false) => {
    if (loadingMore && append) return;

    try {
      if (append) setLoadingMore(true);
      else setLoading(true);

      const params = {
        page: pageNum,
        pageSize: 15,
        keyword: searchKeyword || undefined,
      };
      const data = await adminUserApi.list(params);
      const newCustomers = data?.items || data?.list || [];
      const totalData = data?.total || 0;

      if (append) {
        setCustomers((prev) => {
          const updated = [...prev, ...newCustomers];
          setHasMore(updated.length < totalData);
          return updated;
        });
      } else {
        setCustomers(newCustomers);
        setHasMore(newCustomers.length < totalData);
      }
      setTotal(totalData);
      setPage(pageNum);
    } catch (err) {
      Toast.show('获取客户列表失败');
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const loadMore = async () => {
    if (!hasMore || loadingMore) return;
    await fetchCustomers(page + 1, true);
  };

  const refreshData = async () => {
    setRefreshFlag((prev) => prev + 1);
  };

  const handleSearch = () => {
    setSearchKeyword(keyword);
  };

  const confirmDelete = (id) => {
    Dialog.confirm({
      content: '确定要删除此客户吗？',
      onConfirm: async () => {
        try {
          await adminUserApi.delete(id);
          Toast.show('删除成功');
          fetchCustomers(1);
        } catch (err) {
          Toast.show('删除失败');
        }
      },
    });
  };

  if (loading && customers.length === 0) {
    return (
      <div style={{ padding: 16 }}>
        <Skeleton.Title rows={3} />
        <Skeleton.Title rows={5} style={{ marginTop: 16 }} />
        <Skeleton.Title rows={5} style={{ marginTop: 16 }} />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      {/* 搜索栏 */}
      <div style={{ background: '#fff', padding: '6px 12px' }}>
        <SearchBar
          value={keyword}
          onChange={setKeyword}
          onSearch={handleSearch}
          placeholder="搜索客户"
          style={{ '--background': '#f5f5f5' }}
        />
      </div>

      {/* 客户列表 */}
      <PullToRefresh onRefresh={refreshData}>
        {customers.length > 0 ? (
          <>
            <List>
              {customers.map((customer) => (
                <List.Item
                  key={customer.id}
                  onClick={() => navigate(`/admin/m/customers/${customer.id}`)}
                  style={{
                    background: '#fff',
                    padding: '10px 12px',
                  }}
                  description={
                    <div style={{ marginTop: 4 }}>
                      {customer.phone && (
                        <div style={{ fontSize: 12, color: '#666' }}>
                          📱 {customer.phone}
                        </div>
                      )}
                      {customer.tags && (
                        <div style={{ marginTop: 4, flexWrap: 'wrap', display: 'flex', gap: 4 }}>
                          {customer.tags.split(',').filter(Boolean).map((tag, idx) => (
                            <Tag key={idx} size="small" color="primary">{tag}</Tag>
                          ))}
                        </div>
                      )}
                    </div>
                  }
                  extra={
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <Tag size="small" color={customer.role === 'admin' ? 'danger' : 'success'}>
                          {customer.role === 'admin' ? '管' : '客'}
                        </Tag>
                        <Tag size="small" color={customer.enabled ? 'success' : 'default'}>
                          {customer.enabled ? '启' : '禁'}
                        </Tag>
                      </div>
                      <span
                        style={{ fontSize: 12, color: '#ff4d4f' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          confirmDelete(customer.id);
                        }}
                      >
                        删除
                      </span>
                    </div>
                  }
                >
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 500 }}>
                      {(customer.firstName || customer.lastName)
                        ? `${customer.lastName || ''} ${customer.firstName || ''}`.trim()
                        : '未设置姓名'}
                    </div>
                    <div style={{ fontSize: 12, color: '#666' }}>
                      ✉️ {customer.email}
                    </div>
                  </div>
                </List.Item>
              ))}
              {!hasMore && (
                <div style={{ padding: 20, textAlign: 'center', color: '#999', fontSize: 14 }}>
                  没有更多了
                </div>
              )}
            </List>
            <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
          </>
        ) : (
          <div style={{ padding: '80px 0' }}>
            <Empty description="暂无客户" />
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
